module.exports = __webpack_public_path__ + "img/Layer 9.1e84d8cd.svg";